export default "__VITE_ASSET__BZx52$k1__"